import { put, take, fork, call, getContext } from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';

function* startUpload(url, data) {
  const authApiService = yield getContext('authApiService');

  let emit;
  const channel = eventChannel((emitter) => {
    emit = emitter;
    return () => {
      // do nothing
    };
  });

  const onUploadProgress = ({ total, loaded }) => {
    const percentage = Math.round((loaded * 100) / total);

    emit(percentage);

    if (percentage === 100) {
      emit(END);
    }
  };

  const promise = authApiService.post(url, data, { onUploadProgress });

  return { channel, promise };
}

function* uploadWatcher(channel, progressAction, progressActionArgs) {
  while (true) {
    const progress = yield take(channel);
    yield put(progressAction(...progressActionArgs, progress));
  }
}

export function* uploadFileWithProgressSaga(url, data, progressAction, progressActionArgs) {
  const { channel, promise } = yield call(startUpload, url, data);

  yield fork(uploadWatcher, channel, progressAction, progressActionArgs || []);

  return yield call(() => promise);
}
